import * as React from 'react';
import styled from 'styled-components';

const Main = styled.img`
  image-rendering: crisp-edges;
`;

export const ImageIcon = React.memo((props: any) => {
  const { width, height, src, ...rest } = props;
  return <Main loading="lazy" style={{ width, height }} {...rest} src={src} />;
});
